$(document).ready(() => {
  $('.download-story-button').on('click', () => {
    $('img[loading="lazy"]').each(function() {
      const headerImage = $(this);

      // Set loading to eager
      headerImage.attr('loading', 'eager');

      // Load the image
      if (!headerImage[0].complete) {
        const img = new Image();
        img.src = headerImage.attr('src');
      }
    });

    // Allow the images to load before printing
    setTimeout(() => {
      window.print();
    }, 200);
  });
});
